<section class="section-div">
  <div class="header-div">
    <h4><i class="fas fa-handshake"></i> Commitments From Applicant</h4>
  </div>
  <form action="" [formGroup]="commitments">
    <div class="row">
      <div class="col-lg-4 col-md-6 col-sm-6 col-12">
        <div class="form-rows">
          <mat-form-field class="material-full-width" appearance="outline">
            <mat-label>Host Institution contribution for CoE (INR) </mat-label>
            <input
              matInput
              placeholder="Enter Host Institution (INR)"
              type="text"
              readonly="{{ showForm }}"
              formControlName="hostInsitution"
              oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
              maxlength="11"
              (keydown.enter)="preventEnterKey($event)"
            />
          </mat-form-field>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-6 col-12">
        <div class="form-rows">
          <mat-form-field class="material-full-width" appearance="outline">
            <mat-label>Name of the Industrial Partner </mat-label>
            <input
              matInput
              placeholder="Enter Name of the Industrial Partner"
              type="text"
              readonly="{{ showForm }}"
              formControlName="industrialPartner"
              maxlength="100"
              (keydown.enter)="preventEnterKey($event)"
            />
          </mat-form-field>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-6 col-12">
        <div class="form-rows">
          <mat-form-field class="material-full-width" appearance="outline">
            <mat-label>Industrial Partner Contribution (INR) </mat-label>
            <input
              matInput
              placeholder="Enter Industrial Partner Contribution (INR)"
              type="text"
              readonly="{{ showForm }}"
              formControlName="industrialpartnercontribution"
              oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
              maxlength="11"
              (keydown.enter)="preventEnterKey($event)"
            />
          </mat-form-field>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-6 col-12">
        <div class="form-rows">
          <mat-form-field class="material-full-width" appearance="outline">
            <mat-label
              >Total built-up area available (in sq. ft) for CoE
            </mat-label>
            <input
              matInput
              placeholder="Enter Total built-up area"
              type="text"
              readonly="{{ showForm }}"
              formControlName="totalbuiluparea"
              oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{6})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
              maxlength="11"
              (keydown.enter)="preventEnterKey($event)"
            />
          </mat-form-field>
        </div>
      </div>
    </div>
    <table class="table">
      <thead
        style="
          padding: 18px;
          background-color: #0c0249;
          color: white;
          text-align: center;
          border-top-left-radius: 20px;
          border-bottom-left-radius: 20px;
        "
      >
        <tr>
          <th scope="col">S.No</th>
          <th scope="col">Description</th>
          <th scope="col">Space Proposed (Sq. ft)</th>
          <th scope="col">Document</th>
        </tr>
      </thead>
      <tbody
        style="
          background-color: #fff;
          text-align: center;
          border-top-left-radius: 20px;
          border-bottom-left-radius: 20px;
        "
      >
        <tr>
          <th scope="row" class="pt-4">1</th>
          <td class="pt-4 text-left">
            Incubation space (cubicles and co-working)
          </td>
          <td>
            <div class="form-rows">
              <mat-form-field class="material-full-width" appearance="outline">
                <mat-label>In (sq.ft) </mat-label>
                <input
                  matInput
                  placeholder="In (sq.ft)"
                  type="text"
                  readonly="{{ showForm }}"
                  formControlName="incubationSpace"
                  oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                  maxlength="11"
                  (keydown.enter)="preventEnterKey($event)"
                />
              </mat-form-field>
            </div>
          </td>
          <td>
            <div class="form-rows" *ngIf="!showForm">
              <label
                *ngIf="disName != '✔ Uploaded'"
                for="input-file-id"
                class="md-button md-raised md-primary"
              >
                Choose File
                <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                <span class="ml-3">{{ disName }}</span>
                <input
                  class="d-none"
                  id="input-file-id"
                  type="file"
                  (change)="fileUpload($event)"
                />
              </label>
              <label
                *ngIf="disName == '✔ Uploaded'"
                for="input-file-id"
                class="md-button md-raised md-accent"
              >
                Update File
                <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                <span class="ml-3">{{ disName }}</span>
                <input
                  class="d-none"
                  id="input-file-id"
                  type="file"
                  (change)="fileUpload($event)"
                />
              </label>
              <span class="noti-span">
                (Supported Format: pdf) (max file size: 5mb)
              </span>
              <p *ngIf="fileErrorShow == true" class="text-danger">
                File size exceeds the limit ({{ maxSizeMB }}MB)
              </p>
              <div
                class="mt-2 mb-3"
                *ngIf="disNames == '✔ Uploaded' && getValue"
              >
                <a class="pdf-btn" href="{{ FileName }}" target="_blank"
                  >Download & View Document</a
                >
              </div>
              <mat-error *ngIf="fileError == true">
                <span>Upload Incubation space Document</span>
              </mat-error>
            </div>
            <div class="form-rows" *ngIf="showForm" disabled>
              <label
                *ngIf="disName != '✔ Uploaded'"
                for="input-file-id"
                class="md-button md-raised md-primary"
              >
                Choose File
                <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                <span class="ml-3">{{ disName }}</span>
                <input class="d-none" id="input-file-id" readonly />
              </label>
              <label
                *ngIf="disName == '✔ Uploaded'"
                for="input-file-id"
                class="md-button md-raised md-accent"
                style="cursor: not-allowed"
              >
                Update File
                <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                <span class="ml-3">{{ disName }}</span>
                <input class="d-none" id="input-file-id" readonly />
              </label>
              <span class="noti-span">
                (Supported Format: pdf) (max file size: 5mb)
              </span>
              <p
                *ngIf="
                  logoCheck &&
                  selecetdFile &&
                  selecetdFile.size / (1024 * 1024) > maxSizeMB
                "
                class="text-danger"
              >
                File size exceeds the limit ({{ maxSizeMB }}MB)
              </p>
              <div
                class="mt-2 mb-3"
                *ngIf="disNames == '✔ Uploaded' && getValue"
              >
                <a class="pdf-btn" href="{{ FileName }}" target="_blank"
                  >Download & View Document</a
                >
              </div>
              <mat-error *ngIf="fileError == true">
                <span>Upload Incubation space Document</span>
              </mat-error>
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row" class="pt-4">2</th>
          <td class="pt-4 text-left">Technical Laboratories</td>
          <td>
            <div class="form-rows">
              <mat-form-field class="material-full-width" appearance="outline">
                <mat-label>In (sq.ft) </mat-label>
                <input
                  matInput
                  placeholder="In (sq.ft)"
                  type="text"
                  readonly="{{ showForm }}"
                  formControlName="technicalLaboratories"
                  oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                  maxlength="11"
                  (keydown.enter)="preventEnterKey($event)"
                />
              </mat-form-field>
            </div>
          </td>
          <td>
            <div class="form-rows mt-3" *ngIf="!showForm">
              <label
                *ngIf="disName2 != '✔ Uploaded'"
                for="input-file-id2"
                class="md-button md-raised md-primary"
              >
                Choose File
                <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                <span class="ml-3">{{ disName2 }}</span>
                <input
                  class="d-none"
                  id="input-file-id2"
                  type="file"
                  (change)="fileUpload2($event)"
                />
              </label>
              <label
                *ngIf="disName2 == '✔ Uploaded'"
                for="input-file-id2"
                class="md-button md-raised md-accent"
              >
                Update File
                <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                <span class="ml-3">{{ disName2 }}</span>
                <input
                  class="d-none"
                  id="input-file-id2"
                  type="file"
                  (change)="fileUpload2($event)"
                />
              </label>
              <span class="noti-span">
                (Supported Format: pdf) (max file size: 5mb)
              </span>
              <p *ngIf="fileErrorShow2 == true" class="text-danger">
                File size exceeds the limit ({{ maxSizeMB2 }}MB)
              </p>
              <div
                class="mt-2 mb-3"
                *ngIf="disNames2 == '✔ Uploaded' && getValue"
              >
                <a class="pdf-btn" href="{{ FileName2 }}" target="_blank"
                  >Download & View Document</a
                >
              </div>
              <mat-error *ngIf="fileError2 == true">
                <span>Upload Technical Laboratories Document</span>
              </mat-error>
            </div>

            <div class="form-rows mt-3" *ngIf="showForm" disabled>
              <label
                *ngIf="disName2 != '✔ Uploaded'"
                for="input-file-id2"
                class="md-button md-raised md-primary"
              >
                Choose File
                <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                <span class="ml-3">{{ disName2 }}</span>
                <input class="d-none" id="input-file-id2" readonly />
              </label>
              <label
                *ngIf="disName2 == '✔ Uploaded'"
                for="input-file-id2"
                class="md-button md-raised md-accent"
                style="cursor: not-allowed"
              >
                Update File
                <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                <span class="ml-3">{{ disName2 }}</span>
                <input class="d-none" id="input-file-id2" readonly />
              </label>
              <span class="noti-span">
                (Supported Format: pdf) (max file size: 5mb)
              </span>
              <p
                *ngIf="
                  logoCheck2 &&
                  selecetdFile2 &&
                  selecetdFile2.size / (1024 * 1024) > maxSizeMB2
                "
                class="text-danger"
              >
                File size exceeds the limit ({{ maxSizeMB2 }}MB)
              </p>
              <div
                class="mt-2 mb-3"
                *ngIf="disNames2 == '✔ Uploaded' && getValue"
              >
                <a class="pdf-btn" href="{{ FileName2 }}" target="_blank"
                  >Download & View Document</a
                >
              </div>
              <mat-error *ngIf="fileError2 == true">
                <span>Upload Technical Laboratories Document</span>
              </mat-error>
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row" class="pt-4">3</th>
          <td class="pt-4 text-left">Conference hall</td>
          <td>
            <div class="form-rows">
              <mat-form-field class="material-full-width" appearance="outline">
                <mat-label>In (sq.ft) </mat-label>
                <input
                  matInput
                  placeholder="In (sq.ft)"
                  type="text"
                  readonly="{{ showForm }}"
                  formControlName="conferenceHall"
                  oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                  maxlength="11"
                  (keydown.enter)="preventEnterKey($event)"
                />
              </mat-form-field>
            </div>
          </td>
          <td>
            <div class="form-rows mt-3" *ngIf="!showForm">
              <label
                *ngIf="disName3 != '✔ Uploaded'"
                for="input-file-id3"
                class="md-button md-raised md-primary"
              >
                Choose File
                <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                <span class="ml-3">{{ disName3 }}</span>
                <input
                  class="d-none"
                  id="input-file-id3"
                  type="file"
                  (change)="fileUpload3($event)"
                />
              </label>
              <label
                *ngIf="disName3 == '✔ Uploaded'"
                for="input-file-id3"
                class="md-button md-raised md-accent"
              >
                Update File
                <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                <span class="ml-3">{{ disName3 }}</span>
                <input
                  class="d-none"
                  id="input-file-id3"
                  type="file"
                  (change)="fileUpload3($event)"
                />
              </label>
              <span class="noti-span">
                (Supported Format: pdf) (max file size: 5mb)
              </span>
              <p *ngIf="fileErrorShow3 == true" class="text-danger">
                File size exceeds the limit ({{ maxSizeMB3 }}MB)
              </p>
              <div
                class="mt-2 mb-3"
                *ngIf="disNames3 == '✔ Uploaded' && getValue"
              >
                <a class="pdf-btn" href="{{ FileName3 }}" target="_blank"
                  >Download & View Document</a
                >
              </div>
              <mat-error *ngIf="fileError3 == true">
                <span>Upload Conference hall Document</span>
              </mat-error>
            </div>

            <div class="form-rows mt-3" *ngIf="showForm" disabled>
              <label
                *ngIf="disName3 != '✔ Uploaded'"
                for="input-file-id3"
                class="md-button md-raised md-primary"
              >
                Choose File
                <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                <span class="ml-3">{{ disName3 }}</span>
                <input class="d-none" id="input-file-id3" readonly />
              </label>
              <label
                *ngIf="disName3 == '✔ Uploaded'"
                for="input-file-id3"
                class="md-button md-raised md-accent"
                style="cursor: not-allowed"
              >
                Update File
                <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                <span class="ml-3">{{ disName3 }}</span>
                <input class="d-none" id="input-file-id3" readonly />
              </label>
              <span class="noti-span">
                (Supported Format: pdf) (max file size: 5mb)
              </span>
              <p
                *ngIf="
                  logoCheck3 &&
                  selecetdFile3 &&
                  selecetdFile3.size / (1024 * 1024) > maxSizeMB3
                "
                class="text-danger"
              >
                File size exceeds the limit ({{ maxSizeMB3 }}MB)
              </p>
              <div
                class="mt-2 mb-3"
                *ngIf="disNames3 == '✔ Uploaded' && getValue"
              >
                <a class="pdf-btn" href="{{ FileName3 }}" target="_blank"
                  >Download & View Document</a
                >
              </div>
              <mat-error *ngIf="fileError3 == true">
                <span>Conference hall Document</span>
              </mat-error>
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row" class="pt-4">4</th>
          <td class="pt-4 text-left">Meeting / Networking Room</td>
          <td>
            <div class="form-rows">
              <mat-form-field class="material-full-width" appearance="outline">
                <mat-label>In (sq.ft) </mat-label>
                <input
                  matInput
                  placeholder="In (sq.ft)"
                  type="text"
                  readonly="{{ showForm }}"
                  formControlName="networkinGroom"
                  oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                  maxlength="11"
                  (keydown.enter)="preventEnterKey($event)"
                />
              </mat-form-field>
            </div>
          </td>
          <td>
            <div class="form-rows mt-3" *ngIf="!showForm">
              <label
                *ngIf="disName4 != '✔ Uploaded'"
                for="input-file-id4"
                class="md-button md-raised md-primary"
              >
                Choose File
                <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                <span class="ml-3">{{ disName4 }}</span>
                <input
                  class="d-none"
                  id="input-file-id4"
                  type="file"
                  (change)="fileUpload4($event)"
                />
              </label>
              <label
                *ngIf="disName4 == '✔ Uploaded'"
                for="input-file-id4"
                class="md-button md-raised md-accent"
              >
                Update File
                <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                <span class="ml-3">{{ disName4 }}</span>
                <input
                  class="d-none"
                  id="input-file-id4"
                  type="file"
                  (change)="fileUpload4($event)"
                />
              </label>
              <span class="noti-span">
                (Supported Format: pdf) (max file size: 5mb)
              </span>
              <p *ngIf="fileErrorShow4 == true" class="text-danger">
                File size exceeds the limit ({{ maxSizeMB4 }}MB)
              </p>
              <div
                class="mt-2 mb-3"
                *ngIf="disNames4 == '✔ Uploaded' && getValue"
              >
                <a class="pdf-btn" href="{{ FileName4 }}" target="_blank"
                  >Download & View Document</a
                >
              </div>
              <mat-error *ngIf="fileError4 == true">
                <span>Upload Meeting / Networking Room Document</span>
              </mat-error>
            </div>

            <div class="form-rows mt-3" *ngIf="showForm" disabled>
              <label
                *ngIf="disName4 != '✔ Uploaded'"
                for="input-file-id4"
                class="md-button md-raised md-primary"
              >
                Choose File
                <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                <span class="ml-3">{{ disName4 }}</span>
                <input class="d-none" id="input-file-id4" readonly />
              </label>
              <label
                *ngIf="disName4 == '✔ Uploaded'"
                for="input-file-id4"
                class="md-button md-raised md-accent"
                style="cursor: not-allowed"
              >
                Update File
                <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                <span class="ml-3">{{ disName4 }}</span>
                <input class="d-none" id="input-file-id4" readonly />
              </label>
              <span class="noti-span">
                (Supported Format: pdf) (max file size: 5mb)
              </span>
              <p
                *ngIf="
                  logoCheck4 &&
                  selecetdFile4 &&
                  selecetdFile4.size / (1024 * 1024) > maxSizeMB4
                "
                class="text-danger"
              >
                File size exceeds the limit ({{ maxSizeMB4 }}MB)
              </p>
              <div
                class="mt-2 mb-3"
                *ngIf="disNames4 == '✔ Uploaded' && getValue"
              >
                <a class="pdf-btn" href="{{ FileName4 }}" target="_blank"
                  >Download & View Document</a
                >
              </div>
              <mat-error *ngIf="fileError4 == true">
                <span>Meeting / Networking Room Document</span>
              </mat-error>
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row" class="pt-4">5</th>
          <td class="pt-4 text-left">Cafeteria</td>
          <td>
            <div class="form-rows">
              <mat-form-field class="material-full-width" appearance="outline">
                <mat-label>In (sq.ft) </mat-label>
                <input
                  matInput
                  placeholder="In (sq.ft)"
                  type="text"
                  readonly="{{ showForm }}"
                  formControlName="cafeteria"
                  oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                  maxlength="11"
                  (keydown.enter)="preventEnterKey($event)"
                />
              </mat-form-field>
            </div>
          </td>
          <td>
            <div class="form-rows mt-3" *ngIf="!showForm">
              <label
                *ngIf="disName5 != '✔ Uploaded'"
                for="input-file-id5"
                class="md-button md-raised md-primary"
              >
                Choose File
                <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                <span class="ml-3">{{ disName5 }}</span>
                <input
                  class="d-none"
                  id="input-file-id5"
                  type="file"
                  (change)="fileUpload5($event)"
                />
              </label>
              <label
                *ngIf="disName5 == '✔ Uploaded'"
                for="input-file-id5"
                class="md-button md-raised md-accent"
              >
                Update File
                <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                <span class="ml-3">{{ disName5 }}</span>
                <input
                  class="d-none"
                  id="input-file-id5"
                  type="file"
                  (change)="fileUpload5($event)"
                />
              </label>
              <span class="noti-span">
                (Supported Format: pdf) (max file size: 5mb)
              </span>
              <p *ngIf="fileErrorShow5 == true" class="text-danger">
                File size exceeds the limit ({{ maxSizeMB5 }}MB)
              </p>
              <div
                class="mt-2 mb-3"
                *ngIf="disNames5 == '✔ Uploaded' && getValue"
              >
                <a class="pdf-btn" href="{{ FileName5 }}" target="_blank"
                  >Download & View Document</a
                >
              </div>
              <mat-error *ngIf="fileError5 == true">
                <span>Upload Cafeteria Document</span>
              </mat-error>
            </div>
            <div class="form-rows mt-3" *ngIf="showForm" disabled>
              <label
                *ngIf="disName5 != '✔ Uploaded'"
                for="input-file-id5"
                class="md-button md-raised md-primary"
              >
                Choose File
                <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                <span class="ml-3">{{ disName5 }}</span>
                <input class="d-none" id="input-file-id5" readonly />
              </label>
              <label
                *ngIf="disName5 == '✔ Uploaded'"
                for="input-file-id5"
                class="md-button md-raised md-accent"
                style="cursor: not-allowed"
              >
                Update File
                <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                <span class="ml-3">{{ disName5 }}</span>
                <input class="d-none" id="input-file-id5" readonly />
              </label>
              <span class="noti-span">
                (Supported Format: pdf) (max file size: 5mb)
              </span>
              <p
                *ngIf="
                  logoCheck5 &&
                  selecetdFile5 &&
                  selecetdFile5.size / (1024 * 1024) > maxSizeMB5
                "
                class="text-danger"
              >
                File size exceeds the limit ({{ maxSizeMB5 }}MB)
              </p>
              <div
                class="mt-2 mb-3"
                *ngIf="disNames5 == '✔ Uploaded' && getValue"
              >
                <a class="pdf-btn" href="{{ FileName5 }}" target="_blank"
                  >Download & View Document</a
                >
              </div>
              <mat-error *ngIf="fileError5 == true">
                <span>Cafeteria Document</span>
              </mat-error>
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row" class="pt-4">6</th>
          <td class="pt-4 text-left">Office space for staff</td>
          <td>
            <div class="form-rows">
              <mat-form-field class="material-full-width" appearance="outline">
                <mat-label>In (sq.ft) </mat-label>
                <input
                  matInput
                  placeholder="In (sq.ft)"
                  type="text"
                  readonly="{{ showForm }}"
                  formControlName="officeSpace"
                  oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                  maxlength="11"
                  (keydown.enter)="preventEnterKey($event)"
                />
              </mat-form-field>
            </div>
          </td>
          <td>
            <div class="form-rows mt-3" *ngIf="!showForm">
              <label
                *ngIf="disName6 != '✔ Uploaded'"
                for="input-file-id6"
                class="md-button md-raised md-primary"
              >
                Choose File
                <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                <span class="ml-3">{{ disName6 }}</span>
                <input
                  class="d-none"
                  id="input-file-id6"
                  type="file"
                  (change)="fileUpload6($event)"
                />
              </label>
              <label
                *ngIf="disName6 == '✔ Uploaded'"
                for="input-file-id6"
                class="md-button md-raised md-accent"
              >
                Update File
                <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                <span class="ml-3">{{ disName6 }}</span>
                <input
                  class="d-none"
                  id="input-file-id6"
                  type="file"
                  (change)="fileUpload6($event)"
                />
              </label>
              <span class="noti-span">
                (Supported Format: pdf) (max file size: 5mb)
              </span>
              <p *ngIf="fileErrorShow6 == true" class="text-danger">
                File size exceeds the limit ({{ maxSizeMB6 }}MB)
              </p>
              <div
                class="mt-2 mb-3"
                *ngIf="disNames6 == '✔ Uploaded' && getValue"
              >
                <a class="pdf-btn" href="{{ FileName6 }}" target="_blank"
                  >Download & View Document</a
                >
              </div>
              <mat-error *ngIf="fileError6 == true">
                <span>Upload Office space for staff Document</span>
              </mat-error>
            </div>
            <div class="form-rows mt-3" *ngIf="showForm" disabled>
              <label
                *ngIf="disName6 != '✔ Uploaded'"
                for="input-file-id6"
                class="md-button md-raised md-primary"
              >
                Choose File
                <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                <span class="ml-3">{{ disName6 }}</span>
                <input class="d-none" id="input-file-id6" readonly />
              </label>
              <label
                *ngIf="disName6 == '✔ Uploaded'"
                for="input-file-id6"
                class="md-button md-raised md-accent"
                style="cursor: not-allowed"
              >
                Update File
                <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                <span class="ml-3">{{ disName6 }}</span>
                <input class="d-none" id="input-file-id6" readonly />
              </label>
              <span class="noti-span">
                (Supported Format: pdf) (max file size: 5mb)
              </span>
              <p
                *ngIf="
                  logoCheck6 &&
                  selecetdFile6 &&
                  selecetdFile6.size / (1024 * 1024) > maxSizeMB6
                "
                class="text-danger"
              >
                File size exceeds the limit ({{ maxSizeMB6 }}MB)
              </p>
              <div
                class="mt-2 mb-3"
                *ngIf="disNames6 == '✔ Uploaded' && getValue"
              >
                <a class="pdf-btn" href="{{ FileName6 }}" target="_blank"
                  >Download & View Document</a
                >
              </div>
              <mat-error *ngIf="fileError6 == true">
                <span>Office space for staff Document</span>
              </mat-error>
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row" class="pt-4">7</th>
          <td class="pt-4 text-left">Tech Transfer Hub / Office</td>
          <td>
            <div class="form-rows">
              <mat-form-field class="material-full-width" appearance="outline">
                <mat-label>In (sq.ft) </mat-label>
                <input
                  matInput
                  placeholder="In (sq.ft)"
                  type="text"
                  readonly="{{ showForm }}"
                  formControlName="techTransferHub"
                  oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                  maxlength="11"
                  (keydown.enter)="preventEnterKey($event)"
                />
              </mat-form-field>
            </div>
          </td>
          <td>
            <div class="form-rows mt-3" *ngIf="!showForm">
              <label
                *ngIf="disName7 != '✔ Uploaded'"
                for="input-file-id7"
                class="md-button md-raised md-primary"
              >
                Choose File
                <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                <span class="ml-3">{{ disName7 }}</span>
                <input
                  class="d-none"
                  id="input-file-id7"
                  type="file"
                  (change)="fileUpload7($event)"
                />
              </label>
              <label
                *ngIf="disName7 == '✔ Uploaded'"
                for="input-file-id7"
                class="md-button md-raised md-accent"
              >
                Update File
                <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                <span class="ml-3">{{ disName7 }}</span>
                <input
                  class="d-none"
                  id="input-file-id7"
                  type="file"
                  (change)="fileUpload7($event)"
                />
              </label>
              <span class="noti-span">
                (Supported Format: pdf) (max file size: 5mb)
              </span>
              <p *ngIf="fileErrorShow7 == true" class="text-danger">
                File size exceeds the limit ({{ maxSizeMB7 }}MB)
              </p>
              <div
                class="mt-2 mb-3"
                *ngIf="disNames7 == '✔ Uploaded' && getValue"
              >
                <a class="pdf-btn" href="{{ FileName7 }}" target="_blank"
                  >Download & View Document</a
                >
              </div>
              <mat-error *ngIf="fileError7 == true">
                <span>Upload Tech Transfer Hub / Office Document</span>
              </mat-error>
            </div>
            <div class="form-rows mt-3" *ngIf="showForm" disabled>
              <label
                *ngIf="disName7 != '✔ Uploaded'"
                for="input-file-id7"
                class="md-button md-raised md-primary"
              >
                Choose File
                <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                <span class="ml-3">{{ disName7 }}</span>
                <input class="d-none" id="input-file-id7" readonly />
              </label>
              <label
                *ngIf="disName7 == '✔ Uploaded'"
                for="input-file-id7"
                class="md-button md-raised md-accent"
                style="cursor: not-allowed"
              >
                Update File
                <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                <span class="ml-3">{{ disName7 }}</span>
                <input class="d-none" id="input-file-id7" readonly />
              </label>
              <span class="noti-span">
                (Supported Format: pdf) (max file size: 5mb)
              </span>
              <p
                *ngIf="
                  logoCheck7 &&
                  selecetdFile7 &&
                  selecetdFile7.size / (1024 * 1024) > maxSizeMB7
                "
                class="text-danger"
              >
                File size exceeds the limit ({{ maxSizeMB7 }}MB)
              </p>
              <div
                class="mt-2 mb-3"
                *ngIf="disNames7 == '✔ Uploaded' && getValue"
              >
                <a class="pdf-btn" href="{{ FileName7 }}" target="_blank"
                  >Download & View Document</a
                >
              </div>
              <mat-error *ngIf="fileError7 == true">
                <span>Tech Transfer Hub / Office Document</span>
              </mat-error>
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row" class="pt-4">8</th>
          <td class="pt-4 text-left">Pilot plant related to the sector</td>
          <td>
            <div class="form-rows">
              <mat-form-field class="material-full-width" appearance="outline">
                <mat-label>In (sq.ft) </mat-label>
                <input
                  matInput
                  placeholder="In (sq.ft)"
                  type="text"
                  readonly="{{ showForm }}"
                  formControlName="pilotPlant"
                  oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                  maxlength="11"
                  (keydown.enter)="preventEnterKey($event)"
                />
              </mat-form-field>
            </div>
          </td>
          <td>
            <div class="form-rows mt-3" *ngIf="!showForm">
              <label
                *ngIf="disName8 != '✔ Uploaded'"
                for="input-file-id8"
                class="md-button md-raised md-primary"
              >
                Choose File
                <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                <span class="ml-3">{{ disName8 }}</span>
                <input
                  class="d-none"
                  id="input-file-id8"
                  type="file"
                  (change)="fileUpload8($event)"
                />
              </label>
              <label
                *ngIf="disName8 == '✔ Uploaded'"
                for="input-file-id8"
                class="md-button md-raised md-accent"
              >
                Update File
                <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                <span class="ml-3">{{ disName8 }}</span>
                <input
                  class="d-none"
                  id="input-file-id8"
                  type="file"
                  (change)="fileUpload8($event)"
                />
              </label>
              <span class="noti-span">
                (Supported Format: pdf) (max file size: 5mb)
              </span>
              <p *ngIf="fileErrorShow8 == true" class="text-danger">
                File size exceeds the limit ({{ maxSizeMB8 }}MB)
              </p>
              <div
                class="mt-2 mb-3"
                *ngIf="disNames8 == '✔ Uploaded' && getValue"
              >
                <a class="pdf-btn" href="{{ FileName8 }}" target="_blank"
                  >Download & View Document</a
                >
              </div>
              <mat-error *ngIf="fileError8 == true">
                <span>Upload Pilot plant related to the sector Document</span>
              </mat-error>
            </div>
            <div class="form-rows mt-3" *ngIf="showForm" disabled>
              <label
                *ngIf="disName8 != '✔ Uploaded'"
                for="input-file-id8"
                class="md-button md-raised md-primary"
              >
                Choose File
                <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                <span class="ml-3">{{ disName8 }}</span>
                <input class="d-none" id="input-file-id8" readonly />
              </label>
              <label
                *ngIf="disName8 == '✔ Uploaded'"
                for="input-file-id8"
                class="md-button md-raised md-accent"
                style="cursor: not-allowed"
              >
                Update File
                <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                <span class="ml-3">{{ disName8 }}</span>
                <input class="d-none" id="input-file-id8" readonly />
              </label>
              <span class="noti-span">
                (Supported Format: pdf) (max file size: 5mb)
              </span>
              <p
                *ngIf="
                  logoCheck8 &&
                  selecetdFile8 &&
                  selecetdFile8.size / (1024 * 1024) > maxSizeMB8
                "
                class="text-danger"
              >
                File size exceeds the limit ({{ maxSizeMB8 }}MB)
              </p>
              <div
                class="mt-2 mb-3"
                *ngIf="disNames8 == '✔ Uploaded' && getValue"
              >
                <a class="pdf-btn" href="{{ FileName8 }}" target="_blank"
                  >Download & View Document</a
                >
              </div>
              <mat-error *ngIf="fileError8 == true">
                <span>Pilot plant related to the sector Document</span>
              </mat-error>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="text-center mt-3">
      <button
        mat-raised-button
        color="primary"
        (click)="saveBtn('true')"
        *ngIf="!showForm"
      >
        Save & Continue
      </button>
    </div>
  </form>
</section>
